import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CanActivateLoggedIn} from "./shared/activation/can-activate-logged-in";
import {PersonalInfoComponent} from "./personal-info/personal-info.component";
import {LanguagesResolver} from "./shared/resolvers/languages.resolver";
import {CountriesResolver} from "./shared/resolvers/countries.resolver";
import {HomeComponent} from "./home/home.component";
import {AppMode, LocusRoute} from "./shared/dm";
import {ProfilePictureComponent} from "./profile-picture/profile-picture.component";
import {RedeemVoucherComponent} from "./redeem-voucher/redeem-voucher.component";
import {AccountDeletionComponent} from "./account-deletion/account-deletion.component";
import {SignInMethodsComponent} from "./sign-in-methods/sign-in-methods.component";
import {CommunicationComponent} from "./communication/communication.component";


export const ROUTES: LocusRoute[] = [
  {
    component: HomeComponent,
    path: "",
    ext: {
      name: "",
      description: "",
      icon: "",
      visibleInMenu: false,
      availableForModes: [
        AppMode.ANDROID,
        AppMode.IOS,
        AppMode.WEB
      ],
      dangerOperation: false
    }
  },
  {
    component: PersonalInfoComponent,
    path: "personal-info",
    canActivate: [CanActivateLoggedIn],
    resolve: {
      countries: CountriesResolver,
      languages: LanguagesResolver
    },
    ext: {
      name: $localize `:@@section.personalInfo:Personal info`,
      description: $localize `:@@section.personalInfoDescription:Edit your name, select country, language and more`,
      icon: "badge",
      visibleInMenu: true,
      availableForModes: [
        AppMode.ANDROID,
        AppMode.IOS,
        AppMode.WEB
      ],
      dangerOperation: false
    }
  },
  {
    component: ProfilePictureComponent,
    path: "profile-picture",
    canActivate: [CanActivateLoggedIn],
    ext: {
      name: $localize `:@@common.profilePicture:Profile picture`,
      description: $localize `:@@common.profilePictureDescription:Add or remove your profile picture`,
      icon: "portrait",
      visibleInMenu: true,
      availableForModes: [
        AppMode.ANDROID,
        AppMode.IOS,
        AppMode.WEB
      ],
      dangerOperation: false
    }
  },
  // TODO remove after 4/2026, replaced by password change in `sign-in-methods`
  // {
  //   component: PasswordChangeComponent,
  //   path: "change-password",
  //   canActivate: [CanActivateLoggedIn],
  //   ext: {
  //     name: $localize `:@@section.changePassword:Change password`,
  //     description: $localize `:@@section.changePasswordDescription:Just in case you use email/password login`,
  //     icon: "password",
  //     visibleInMenu: true,
  //     availableForModes: [
  //       AppMode.ANDROID,
  //       AppMode.IOS,
  //       AppMode.WEB
  //     ],
  //     dangerOperation: false
  //   }
  // },
  {
    component: RedeemVoucherComponent,
    path: "redeem-voucher",
    canActivate: [CanActivateLoggedIn],
    ext: {
      name: $localize `:@@section.redeemVoucher:Redeem voucher`,
      description: $localize `:@@section.redeemVoucherDescription:You can redeem your voucher here`,
      icon: "subtitles",
      visibleInMenu: true,
      availableForModes: [
        AppMode.WEB
      ],
      dangerOperation: false
    }
  },
  {
    component: SignInMethodsComponent,
    path: "sign-in-methods",
    canActivate: [CanActivateLoggedIn],
    ext: {
      name: $localize `:@@section.signInMethods:Log-in methods`,
      description: $localize `:@@section.signInMethods.description:Manage your login process.`,
      icon: "link",
      visibleInMenu: true,
      availableForModes: [
        AppMode.WEB,
        // View only - SSO is not working properly in WebView
        AppMode.ANDROID,
        // View only - SSO is not working properly
        AppMode.IOS,
      ],
      dangerOperation: false
    }
  },
  {
    component: CommunicationComponent,
    path: "contact",
    canActivate: [CanActivateLoggedIn],
    ext: {
      name: $localize `:@@section.communication:Contact`,
      description: $localize `:@@section.communication.description:Select the email address that we should use to contact you.`,
      icon: "alternate_email",
      visibleInMenu: true,
      availableForModes: [
        AppMode.WEB,
        AppMode.IOS,
        AppMode.ANDROID,
      ],
      dangerOperation: false
    }
  },
  {
    component: AccountDeletionComponent,
    path: "delete-account",
    canActivate: [CanActivateLoggedIn],
    ext: {
      name: $localize `:@@section.accountDeletion:Delete account`,
      description: $localize `:@@section.accountDeletion.description:Send a request to delete your account and all associated data`,
      icon: "person_off",
      visibleInMenu: true,
      availableForModes: [
        AppMode.ANDROID,
        AppMode.IOS,
        AppMode.WEB
      ],
      dangerOperation: true
    }
  }
  // {
  //   component: SubscriptionComponent,
  //   path: "subscription",
  //   canActivate: [CanActivateLoggedIn],
  //   ext: {
  //     name: $localize `:@@common.subscription:Subscription`,
  //     icon: "workspace_premium",
  //     availableForModes: [AppMode.ANDROID, AppMode.WEB]
  //   }
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
